import type { SVGProps } from 'react';

const SvgCanFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="15"
    fill="none"
    viewBox="0 0 22 15"
    {...props}
  >
    <path fill="#FAFAFA" d="M22 0H0v15h22z" />
    <path
      fill="#D80621"
      d="m13 8.333 2-1.066-1-.534V5.667l-2 1.066L13 4.6h-1L11 3l-1 1.6H9l1 2.133-2-1.066v1.066l-1 .534 2 1.066L8.5 9.4h2V11h1V9.4h2zM0 0h6v15H0zm16 0h6v15h-6z"
    />
  </svg>
);
export default SvgCanFlag;
